export const TOOLBAR_TOOLTIP = {
    side: 'bottom',
    align: 'end',
    collisionPadding: 8,
    className: 'bg-foreground border-0 text-background'
} as const;
